import { makeAutoObservable } from "mobx";
import http from "../services/http";

class LicensesStore {
  data: ILicense[] = [];
  item?: ILicense;
  lookups?: ILookups;
  history?: ILicenseHistory[];
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  async findAll(values: any = {}) {
    this.isLoading = true;
    try {
      const result = await http.get("/licenses", { params: values });

      // Нормализуем даты
      this.data = result.data.data.map((l: any) => ({
        ...l,
        startsAt: new Date(l.startsAt),
        expiresAt: new Date(l.expiresAt),
        createdAt: new Date(l.createdAt),
      }));
    } catch (error) {
      console.error("Ошибка при загрузке лицензий:", error);
      this.data = [];
    } finally {
      this.isLoading = false;
    }
  }

  clear() {
    this.data = [];
    this.item = undefined;
    this.lookups = undefined;
    this.history = undefined;
  }
}

const licensesStore = new LicensesStore();
export default licensesStore;

export interface ILicenseHistory {
  id: string;
  name: string;
  action: {
    value: string;
    title: string;
  };
  policiesList: string[];
  expirationDate: Date;
  createdAt: Date;
}

export interface ILookups {
  tariffs: ITariff[];
  limits: ILimit[];
}

export interface ITariff {
  id: string;
  name: string;
  limits: ILimitRecord[];
}

export interface ILimit {
  value: string;
  title: string;
}

export interface ILimitRecord {
  id: string;
  key: ILimit;
  value: number;
}

export interface ILicense {
  id: string;
  tariff: ITariff;
  limits: ILimitRecord[];
  startsAt: Date;
  expiresAt: Date;
  createdAt: Date;
  description?: string;
}
